import {
  getRandomWaveform,
  stringToSeed
} from '../../../../../../shared/waveform';
import type { PeaksSettings, SourceType } from '../../../../../../types';
import { WAVEFORM_SAMPLES } from '../../../../../constants';
import type { ExtendedAudioItem } from '../../../../sources';
import { decodePeaks } from './decodePeaks';
import { generateMinimalPeaks } from './generateMinimalPeaks';

const isValidPeaks = (peaks?: string) => {
  return typeof peaks === 'string' && peaks.length > 0;
};

const hasPeaksProperty = (item: ExtendedAudioItem) => {
  return item && typeof item === 'object';
};

interface GetDecompressedPeaksParams {
  sourceType: SourceType;
  currentItem?: ExtendedAudioItem;
  globalPeaksSettings?: PeaksSettings;
}

export const getDecompressedPeaks = ({
  currentItem,
  sourceType,
  globalPeaksSettings
}: GetDecompressedPeaksParams) => {
  if (
    !currentItem ||
    !hasPeaksProperty(currentItem) ||
    currentItem.peaks?.status === 'pending'
  ) {
    return null;
  }

  const peaksValue = currentItem.peaks?.value;

  const isNeedToGenerateRandomPeaks =
    (currentItem.peaks?.status === 'error' && !peaksValue) ||
    !peaksValue ||
    !isValidPeaks(peaksValue);

  const effectivePeaksSettings =
    currentItem._trackPeaksSettings ?? globalPeaksSettings;

  if (isNeedToGenerateRandomPeaks) {
    const randomWaveform = getRandomWaveform(
      WAVEFORM_SAMPLES,
      stringToSeed(currentItem.id || currentItem.link)
    );

    try {
      return decodePeaks(randomWaveform, sourceType, effectivePeaksSettings);
    } catch (error) {
      console.error('Failed to decode generated waveform:', error);
      return generateMinimalPeaks();
    }
  }

  try {
    return decodePeaks(peaksValue, sourceType, effectivePeaksSettings);
  } catch (error) {
    console.error('Failed to decode peaks:', error);
    return generateMinimalPeaks();
  }
};
